import overrides from '../../common/overrides';
import MuiListItem from './MuiListItem';

export default {
  ...overrides,
  MuiListItem,
};
